import React from 'react';
import { Button } from '../UI-CHAKRA/Button';

interface SearchResultItemProps {
  children: React.ReactNode;
  onClick(): void;
  isPremiumPlacement?: boolean;
}

export default function SearchResultItem(props: SearchResultItemProps) {
  return (
    <Button
      onClick={props.onClick}
      _hover={{ backgroundColor: props.isPremiumPlacement ? '#faf4e1' : '#F1F7FF' }}
      padding={{ base: '10px', md: '10px 20px 10px 0' }}
      cursor={'pointer'}
      variant={'ghost'}
      w={'100%'}
      h={'auto'}
      textAlign={'left'}
      borderRadius={0}
      minHeight={'55px'}
      bgColor={props.isPremiumPlacement ? '#FFFBED' : 'white'}
    >
      {props.children}
    </Button>
  );
}
